import { ReportTypesAgency } from "./AgencyMasterProperties";

export class AgencyRightsProperties {
  agencyRightId: number = 0
  agencyId: string = "";
  profileUpdate: boolean = false;
  isRegisterBecomePartnerList: boolean = false;
  supplierManagement: boolean = false;
  beneficiaryAccount: boolean = false;
  paymentProcess: boolean = false;
  addPayment: boolean = false;
  deletePayment: boolean = false;
  approvePayment: boolean = false;
  creditLimit: boolean = false;
  notifications: boolean = false;
  offlineRequest: boolean = false;
  revenueManagement: boolean = false;
  offlineSettings: boolean = false;
  cms: boolean = false;
  accountManagement: boolean = false;
  account: boolean = false;
  users: boolean = false;
  agencyManagement: boolean = false;
  branchManagement: boolean = false;
  logs: boolean = false;
  currency: boolean = false;
  bookings: boolean = false;
  searchBookings: boolean = false;
  viewBookings: boolean = false;
  updateBookings: boolean = false;
  creationUser: number = 0;
  creationDate: string = "";
  modifyUser: number = 0;
  modifyDate: string = "";
  dashboard: boolean = false;
  reports: boolean = false;
  // agents
  quotations: boolean = false;
  book: boolean = false;
  issueTicket: boolean = false;
  issuePNR: boolean = false;
  cancelTicket: boolean = false;
  cancelPNR: boolean = false;

  voidTicket: boolean = false;
  fareRulesResult: boolean = false;
  viewSubAgentBookings: boolean = false;

  reprice: boolean = false;

  markup: boolean = false;

  refund: boolean = false;
  offlineRefund: boolean = false;
  offlineBooking: boolean = false;
  offlineTicket: boolean = false;
  offlineVoid: boolean = false;
  offlineDealsByCMS: boolean = false;

  exchange: boolean = false;

  calenderSearch: boolean = false;

  recentSearch: boolean = false;

  adminPanelLogin: boolean = false;

  newBookings: boolean = false;
  myBookings: boolean = false;
  importPNR: boolean = false;
  reportsManagement: boolean = false;

  reportTypesRights: ReportTypesAgency[] = [];
  reportRights: ReportAgencyRightsProperties[] = [];
  reportUserRights: ReportUserRightsProperties[] = [];
  companyMasterRight:boolean=false;

  groupTicketRight:boolean=false;
  groupTicketCreateRight:boolean=false;
  groupTicketListRight:boolean=false;
  modifyBooking:boolean;
  //10-June-24
  groupTicketShowRight: boolean = false;

  insuranceRight: boolean = false;
  insuranceIssuanceRight: boolean = false;
  insuranceBookedViewRight: boolean = false;
  insuranceCancelRight: boolean = false;
  offlineManage: boolean = false;
  offlineManageRefund: boolean = false;
  offlineManageBooking: boolean = false;
  offlineManageTicket: boolean = false;
  offlineManageVoid: boolean = false;
  offlineManageResissue: boolean = false;
  offlineResissue: boolean = false;
  //end
}
export class ReportAgencyRightsProperties {
  reportAgencyRightId: number = 0;
  status: boolean = false;
  reportTypeName: string = "";
  agencyBranchId: string = "";
  modifyUser: number = 0;
  pageLink: string = "";
}
export class ReportUserRightsProperties {
  reportAgencyRightId: number = 0;
  status: boolean = false;
  reportTypeName: string = "";
  userId: number = 0;
  modifyUser: number = 0;
  pageLink: string = "";
}
export class ReturnToFrontPropertiesforAgency {
  reportTypesRights: ReportTypesAgency[] = [];
  isSave: boolean = false;
  message: boolean = false;
}

